import React, {useEffect, useRef, useState, useCallback} from 'react'

import {
  Wrapper,
  Dropdown,
  LoadingState,
  EmptyState,
  DropdownItem,
  ItemContent,
  ItemTitle,
  ItemSubtitle,
  Spinner,
  // AddButtonWrapper,
} from './AsyncSearchField.style'

import {Input} from '../../../../shared/Input'
import {useAuthClient} from '../../../../../utils/use-auth-client'
import {
  // StyledAddIcon,
  StyledSearchIcon,
} from '../../../../shared/icons/icons.styles'
import {Button} from '../../../../shared/Button'

export function AsyncSearchField({
  field,
  value,
  values,
  country: countryProp,
  variant,
  size,
  disabled,
  error,
  touched,

  onBlur = () => {},
  onChange,
}) {
  const client = useAuthClient()

  const [query, setQuery] = useState(value?.label || '')
  const [selectedOption, setSelectedOption] = useState(null)
  const [fieldUpdated, setFieldUpdated] = useState(false)
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const wrapperRef = useRef(null)

  // ─────────────────────────────────────────────
  // Salesforce Search
  // ─────────────────────────────────────────────

  const fetchNameOptions = useCallback(
    async inputValue => {
      let sftoken = sessionStorage.getItem('sfToken') || ''

      // country prop (from LocationForm's resolved selectedCountry) takes precedence
      // over values.country (form field), with 'US' as final fallback
      const selectedCountry = countryProp || values?.country || 'US'

      if (sftoken.length > 0) {
        sftoken = JSON.parse(sftoken)

        sftoken = sftoken.nonAusToken
        // selectedCountry === 'AU' ? sftoken.ausToken : sftoken.nonAusToken
      }

      const response = await client(
        `salesforce/services/fetchUsers?token=${sftoken}&searchTerm=${inputValue}&country=${selectedCountry}`,
      )

      const filteredData = (response?.data || []).filter(item =>
        item.Name?.toLowerCase().includes(inputValue.toLowerCase()),
      )

      return filteredData.map(item => ({
        label: item.Name,
        value: item.Name,
        subtitle: item.Email || item.Username || '',
        repInfo: item,
      }))
    },
    [client, countryProp, values?.country],
  )

  // ─────────────────────────────────────────────
  // Search effect
  // ─────────────────────────────────────────────

  useEffect(() => {
    if (query.length < 2) {
      setResults([])
      return
    }

    const timeout = setTimeout(async () => {
      try {
        setLoading(true)

        const data = await fetchNameOptions(query)

        setResults(data || [])
      } catch (error) {
        console.error(error)

        setResults([])
      } finally {
        setLoading(false)
      }
    }, 400)

    return () => clearTimeout(timeout)
  }, [query, fetchNameOptions])

  // ─────────────────────────────────────────────
  // Outside click
  // ─────────────────────────────────────────────

  useEffect(() => {
    const handleOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)

        onBlur?.(field.key)
      }
    }

    document.addEventListener('mousedown', handleOutside)

    return () => {
      document.removeEventListener('mousedown', handleOutside)
    }
  }, [field.key, onBlur])

  const handleAdd = () => {
    onChange(field.key, selectedOption)
    setFieldUpdated(true)
  }
  const handleCancel = () => {
    onChange(field.key, {})
    setSelectedOption(null)
    setQuery('')
    setFieldUpdated(false)
  }

  // ─────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────

  return (
    <Wrapper ref={wrapperRef}>
      <Input
        label={field.label}
        placeholder={field.placeholder}
        value={query}
        variant={variant}
        size={size}
        disabled={disabled}
        labelLeftIcon={field.labelLeftIcon}
        leftIcon={<StyledSearchIcon />}
        rightAction={
          selectedOption && !fieldUpdated ? (
            <Button
              variant="secondary-field-blue"
              size="xl"
              onClick={handleAdd}
            >
              <span>+</span>
              <span>Add</span>
            </Button>
          ) : fieldUpdated ? (
            <Button
              variant="secondary-field-danger"
              size="xl"
              onClick={handleCancel}
            >
              <span>x</span>
            </Button>
          ) : null
        }
        infoText={field.infoText}
        infoLink={field.infoLink}
        infoLinkLabel={field.infoLinkLabel}
        helperText={field.helperText}
        errorText={error}
        required={field.validators?.includes('required')}
        onFocus={() => setOpen(true)}
        onChange={e => {
          setQuery(e.target.value)
          setSelectedOption(null)
          setFieldUpdated(false)
          setOpen(true)
        }}
      />

      {open && query.length >= 2 && (
        <Dropdown>
          {loading && (
            <LoadingState>
              <Spinner />
              Searching...
            </LoadingState>
          )}

          {!loading &&
            results.map(item => (
              <DropdownItem
                key={item.value}
                type="button"
                onClick={() => {
                  setSelectedOption(item)
                  setQuery(item.label)
                  setOpen(false)
                  setFieldUpdated(false)
                }}
              >
                <ItemContent>
                  <ItemTitle>{item.label}</ItemTitle>

                  {item.subtitle && (
                    <ItemSubtitle>{item.subtitle}</ItemSubtitle>
                  )}
                </ItemContent>
              </DropdownItem>
            ))}

          {!loading && results.length === 0 && (
            <EmptyState>No results found</EmptyState>
          )}
        </Dropdown>
      )}
    </Wrapper>
  )
}

// import React, {useEffect, useRef, useState, useCallback} from 'react'

// import {
//   Wrapper,
//   Dropdown,
//   LoadingState,
//   EmptyState,
// } from './AsyncSearchField.style'

// import {Input} from '../../../../shared/Input'
// import {useAuthClient} from '../../../../../utils/use-auth-client'

// export function AsyncSearchField({
//   field,
//   value,
//   variant,
//   size,
//   disabled,
//   error,
//   touched,

//   onBlur = () => {},
//   onChange,
//   country,
// }) {
//   const client = useAuthClient()

//   const [query, setQuery] = useState(value?.label || '')
//   const [results, setResults] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [open, setOpen] = useState(false)

//   const wrapperRef = useRef(null)

//   // ─────────────────────────────────────────────
//   // Salesforce Search
//   // ─────────────────────────────────────────────

//   const fetchNameOptions = useCallback(
//     async inputValue => {
//       let sftoken = sessionStorage.getItem('sfToken') || ''

//       const selectedCountry = country || 'US'

//       if (sftoken.length > 0) {
//         sftoken = JSON.parse(sftoken)

//         sftoken =
//           selectedCountry === 'AU' ? sftoken.ausToken : sftoken.nonAusToken
//       }

//       const response = await client(
//         `salesforce/services/fetchUsers?token=${sftoken}&searchTerm=${inputValue}&country=${selectedCountry}`,
//       )

//       const filteredData = (response?.data || []).filter(item =>
//         item.Name?.toLowerCase().includes(inputValue.toLowerCase()),
//       )

//       return filteredData.map(item => ({
//         label: item.Name,
//         value: item.Name,
//         salesRepInfo: item,
//       }))
//     },
//     [client, country],
//   )

//   // ─────────────────────────────────────────────
//   // Search effect
//   // ─────────────────────────────────────────────

//   useEffect(() => {
//     if (query.length < 2) {
//       setResults([])
//       return
//     }

//     const timeout = setTimeout(async () => {
//       try {
//         setLoading(true)

//         const data = await fetchNameOptions(query)

//         setResults(data || [])
//       } catch (error) {
//         console.error(error)

//         setResults([])
//       } finally {
//         setLoading(false)
//       }
//     }, 400)

//     return () => clearTimeout(timeout)
//   }, [query, fetchNameOptions])

//   // ─────────────────────────────────────────────
//   // Outside click
//   // ─────────────────────────────────────────────

//   useEffect(() => {
//     const handleOutside = e => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         setOpen(false)

//         onBlur?.(field.key)
//       }
//     }

//     document.addEventListener('mousedown', handleOutside)

//     return () => {
//       document.removeEventListener('mousedown', handleOutside)
//     }
//   }, [field.key, onBlur])

//   // ─────────────────────────────────────────────
//   // Render
//   // ─────────────────────────────────────────────

//   return (
//     <Wrapper ref={wrapperRef}>
//       <Input
//         label={field.label}
//         placeholder={field.placeholder}
//         value={query}
//         variant={variant}
//         size={size}
//         disabled={disabled}
//         labelLeftIcon={field.labelLeftIcon}
//         infoText={field.infoText}
//         infoLink={field.infoLink}
//         infoLinkLabel={field.infoLinkLabel}
//         helperText={field.helperText}
//         errorText={error}
//         required={field.validators?.includes('required')}
//         onFocus={() => setOpen(true)}
//         onChange={e => {
//           setQuery(e.target.value)
//           setOpen(true)
//         }}
//       />

//       {open && query.length >= 2 && (
//         <Dropdown>
//           {loading && <LoadingState>Searching...</LoadingState>}

//           {!loading &&
//             results.map(item => (
//               <button
//                 key={item.Name}
//                 type="button"
//                 onClick={() => {
//                   onChange(field.key, item)

//                   setQuery(item.label)

//                   setOpen(false)
//                 }}
//               >
//                 {item.label}
//               </button>
//             ))}

//           {!loading && results.length === 0 && (
//             <EmptyState>No results found</EmptyState>
//           )}
//         </Dropdown>
//       )}
//     </Wrapper>
//   )
// }
